import React from 'react';
import { Form } from 'react-bootstrap';

export interface ThInputTextAreaProps {
  label: string;
  value: string;
  placeholder?: string;
  required: boolean;
  rowCount: number;
  onChange?: (value: string) => void;
  mb?: number;
}

function ThInputTextArea({
  label,
  value,
  placeholder = 'Enter here',
  required,
  rowCount,
  onChange,
  mb = 24
}: ThInputTextAreaProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Form.Group
      style={{marginBottom: `${mb}px`}}
      controlId={label.replace(/\s+/g, '')}
    >
      <Form.Label>{label}</Form.Label>
      <Form.Control
        as='textarea'
        rows={rowCount}
        placeholder={placeholder}
        required={required}
        defaultValue={value}
        onChange={handleChange}
      />
    </Form.Group>
  );
}

export default ThInputTextArea;
